/* eslint-disable */
import { useState, useEffect } from "react";

// react-github-btn
import GitHubButton from "react-github-btn";

// clsx is a utility for constructing className strings conditionally
import clsx from "clsx";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// @mui material components
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// @mui icons
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";

// Custom styles for the Configurator
import styles from "examples/Configurator/styles";

// Soft UI Dashboard PRO React context
import { useSoftUIController } from "context";
import SuiInput from "components/SuiInput";

import { format, subHours, addDays, startOfDay } from "date-fns";
import { DateRangePicker } from "react-date-range";
import { th } from "date-fns/locale";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { SearchMember } from "api/member";
import { transactionHistory } from "api/member";
import moment from "moment";
import { formatter } from "utils/validations";
import { Grid } from "@mui/material";
import SuiBadge from "components/SuiBadge";
import DataTable from "examples/Tables/DataTable";
import { transferCreditHistory } from "api/member";
import ufalabel from "assets/png/ufalabel.png";
import bflabel from "assets/png/bflabel.png";
import { MemberCreditHistory } from "api/member";

const transColomn = [
  {
    Header: "รายการ",
    accessor: "type",
    Cell: ({ value }) => {
      let type;

      if (value === "deposit") {
        type = (
          <SuiBadge
            color="success"
            badgeContent={"ฝาก"}
            size="small"
            circular
            variant="contained"
          />
        );
      } else if (value === "withdraw") {
        type = (
          <SuiBadge color="error" badgeContent={"ถอน"} size="small" circular variant="contained" />
        );
      } else {
        type = (
          <SuiBadge
            color="secondary"
            badgeContent={" - "}
            size="small"
            circular
            variant="contained"
          />
        );
      }

      return type;
    },
  },
  { Header: "จำนวน", accessor: "amount" },
  {
    Header: "วันที่/เวลา",
    accessor: "updatedAt",
    Cell: ({ value }) => {
      const type = format(new Date(value), "dd-MM-yyyy HH:mm");

      return type;
    },
  },
];

const transferColomn = [
  {
    Header: "รายการ",
    accessor: "type",
    Cell: ({ value }) => {
      let type;

      if (value === "add") {
        type = (
          <SuiBadge
            color="success"
            badgeContent={"เพิ่ม"}
            size="small"
            circular
            variant="contained"
          />
        );
      } else if (value === "remove") {
        type = (
          <SuiBadge color="error" badgeContent={"ลด"} size="small" circular variant="contained" />
        );
      } else {
        type = (
          <SuiBadge
            color="secondary"
            badgeContent={" - "}
            size="small"
            circular
            variant="contained"
          />
        );
      }

      return type;
    },
  },
  {
    Header: "ค่าย",
    accessor: "remark",
    Cell: ({ value }) => {
      let remark;

      if (value.includes("betflix")) {
        remark = (
          <SuiBox
            component="img"
            src={bflabel}
            alt="message-image"
            borderRadius="lg"
            boxShadow="md"
            display="inherit"
            width="45px"
          />
        );
      } else if (value.includes("ufa")) {
        remark = (
          <SuiBox
            component="img"
            src={ufalabel}
            alt="message-image"
            borderRadius="lg"
            boxShadow="md"
            display="inherit"
            width="45px"
          />
        );
      }

      return remark;
    },
  },
  { Header: "จำนวน", accessor: "credit" },
  {
    Header: "วันที่/เวลา",
    accessor: "updatedAt",
    Cell: ({ value }) => {
      const type = format(new Date(value), "dd-MM-yyyy HH:mm");

      return type;
    },
  },
];

const creditColomn = [
  {
    Header: "รายการ",
    accessor: "type",
    Cell: ({ value }) => {
      let type;

      if (value === "add") {
        type = (
          <SuiBadge
            color="success"
            badgeContent={"เพิ่ม"}
            size="small"
            circular
            variant="contained"
          />
        );
      } else if (value === "remove") {
        type = (
          <SuiBadge color="error" badgeContent={"ลด"} size="small" circular variant="contained" />
        );
      } else {
        type = (
          <SuiBadge
            color="secondary"
            badgeContent={" - "}
            size="small"
            circular
            variant="contained"
          />
        );
      }

      return type;
    },
  },
  { Header: "จำนวน", accessor: "credit" },
  { Header: "Remark", accessor: "remark" },
  {
    Header: "วันที่/เวลา",
    accessor: "updatedAt",
    Cell: ({ value }) => {
      const type = format(new Date(value), "dd-MM-yyyy HH:mm");

      return type;
    },
  },
];

function Configurator() {
  const [controller, dispatch] = useSoftUIController();
  const { openConfigurator, sidenavColor } = controller;
  const [disabled, setDisabled] = useState(false);
  const classes = styles({ sidenavColor });
  const [username, setUsername] = useState("");
  const [isPicker, setPicker] = useState(false);
  const [member, setMember] = useState();
  const [startDate, setStartDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const [endDate, setEndDate] = useState(format(new Date(), "yyyy-MM-dd"));

  const [tabMenu, setTabMenu] = useState(0);

  const [transactionRows, setTransactionRows] = useState([]);
  const [transferRows, setTransferRows] = useState([]);
  const [creditRows, setCreditRows] = useState([]);

  const [transactionTable, setTransactionTable] = useState({ columns: [], rows: [] });
  const [transferTable, setTransferTable] = useState({ columns: [], rows: [] });
  const [creditTable, setCreditTable] = useState({ columns: [], rows: [] });
  const [isFilterTable, setFilterTable] = useState(false);
  const [totalDeposit, setTotalDeposit] = useState();
  const [totalWithdraw, setTotalWithdraw] = useState();
  const [rangeDeposit, setRangeDeposit] = useState();
  const [rangeWithdraw, setRangeWithdraw] = useState();

  // Use the useEffect hook to change the button state for the sidenav type based on window size.
  useEffect(() => {
    // A function that sets the disabled state of the buttons for the sidenav type.
    function handleDisabled() {
      return window.innerWidth > 1200 ? setDisabled(false) : setDisabled(true);
    }

    // The event listener that's calling the handleDisabled function when resizing the window.
    window.addEventListener("resize", handleDisabled);

    // Call the handleDisabled function to set the state with the initial value.
    handleDisabled();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleDisabled);
  }, []);

  const handleCloseConfigurator = () => {
    dispatch({ type: "OPEN_CONFIGURATOR", value: false });
  };

  const handleSetFilterTable = () => {
    const isShowByDate = !isFilterTable;

    setFilterTable(isShowByDate);

    if (isShowByDate === true) {
      handleFilterbyDate();
    } else {
      setTransactionTable({ columns: transColomn, rows: transactionRows });
      setTransferTable({ columns: transferColomn, rows: transferRows });
      setCreditTable({ columns: creditColomn, rows: creditRows });
    }
  };

  const handleFilterbyDate = () => {
    const transactions = transactionRows.reduce((list, item) => {
      const itemDate = format(new Date(item?.updatedAt), "yyyy-MM-dd");
      if (itemDate >= startDate && itemDate <= endDate) {
        list.push(item);
      }
      return list;
    }, []);

    const transfers = transferRows.reduce((list, item) => {
      const itemDate = format(new Date(item?.updatedAt), "yyyy-MM-dd");
      if (itemDate >= startDate && itemDate <= endDate) {
        list.push(item);
      }
      return list;
    }, []);

    const credits = creditRows.reduce((list, item) => {
      const itemDate = format(new Date(item?.updatedAt), "yyyy-MM-dd");
      if (itemDate >= startDate && itemDate <= endDate) {
        list.push(item);
      }
      return list;
    }, []);

    setTransactionTable({ columns: transColomn, rows: transactions });
    setTransferTable({ columns: transferColomn, rows: transfers });
    setCreditTable({ columns: creditColomn, rows: credits });
  };

  function handleSelectDateRange(v) {
    console.log("Configurator -> handleSelectDateRange - v", v);
    setStartDate(format(new Date(v?.selection?.startDate), "yyyy-MM-dd"));
    setEndDate(format(new Date(v?.selection?.endDate), "yyyy-MM-dd"));
  }

  const handleSetTab = (event, newTab) => setTabMenu(newTab);

  const handleSearch = async (event) => {
    console.log("Configurator - handleSearch", event);
    if (event) {
      event.preventDefault();
    }
    if (!username) {
      return;
    }
    try {
      const res = await SearchMember({ username: username });

      console.log("Configurator -> handleSearch - res", res);
      const m = res?.data?.data ?? {};
      setMember(m);
      handleGetDepositWithdraw(m?.member_uid);
      handleGetTransferHistory(m?.member_uid);
      handleGetCreditHistory(m?.member_uid);
    } catch (error) {}
  };

  const handleGetDepositWithdraw = async (member_uid) => {
    try {
      const response = await transactionHistory({ member_uid: member_uid });
      const data = response?.data?.data?.result ?? [];
      const sumAllDeposit = data.reduce((acc, item) => {
        if (item?.deposit_uid) {
          let value = parseFloat(item.amount);
          if (isNaN(value)) value = 0;
          return acc + value;
        }
        return acc;
      }, 0);

      const sumAllWithdraw = data.reduce((acc, item) => {
        if (item?.withdraw_uid) {
          let value = parseFloat(item.amount);
          if (isNaN(value)) value = 0;
          return acc + value;
        }
        return acc;
      }, 0);

      const sumRangeDeposit = data.reduce((acc, item) => {
        const itemDate = format(new Date(item?.updatedAt), "yyyy-MM-dd");
        if (item?.deposit_uid && itemDate >= startDate && itemDate <= endDate) {
          let value = parseFloat(item.amount);
          if (isNaN(value)) value = 0;
          return acc + value;
        }
        return acc;
      }, 0);

      const sumRangeWithdraw = data.reduce((acc, item) => {
        const itemDate = format(new Date(item?.updatedAt), "yyyy-MM-dd");
        if (item?.withdraw_uid && itemDate >= startDate && itemDate <= endDate) {
          let value = parseFloat(item.amount);
          if (isNaN(value)) value = 0;
          return acc + value;
        }
        return acc;
      }, 0);

      setTransactionRows(data);

      setTransactionTable({ columns: transColomn, rows: data });

      setTotalDeposit(sumAllDeposit);
      setTotalWithdraw(sumAllWithdraw);

      setRangeDeposit(sumRangeDeposit);
      setRangeWithdraw(sumRangeWithdraw);
    } catch (error) {}
  };

  const handleGetTransferHistory = async (member_uid) => {
    try {
      const response = await transferCreditHistory({ member_uid: member_uid });
      const data = response?.data?.data?.result ?? [];
      setTransferRows(data);
      setTransferTable({ columns: transferColomn, rows: data });
    } catch (error) {}
  };

  const handleGetCreditHistory = async (member_uid) => {
    try {
      const response = await MemberCreditHistory({ member_uid: member_uid });
      const data = response?.data?.data?.result ?? [];
      setCreditRows(data);
      setCreditTable({ columns: creditColomn, rows: data });
    } catch (error) {}
  };

  const handleFilterDate = async () => {
    setPicker(false);
    const data = transactionTable?.rows;
    const sumAllDeposit = data.reduce((acc, item) => {
      if (item?.deposit_uid) {
        let value = parseFloat(item.amount);
        if (isNaN(value)) value = 0;
        return acc + value;
      }
      return acc;
    }, 0);

    const sumAllWithdraw = data.reduce((acc, item) => {
      if (item?.withdraw_uid) {
        let value = parseFloat(item.amount);
        if (isNaN(value)) value = 0;
        return acc + value;
      }
      return acc;
    }, 0);

    const sumRangeDeposit = data.reduce((acc, item) => {
      const itemDate = format(new Date(item?.updatedAt), "yyyy-MM-dd");
      if (item?.deposit_uid && itemDate >= startDate && itemDate <= endDate) {
        let value = parseFloat(item.amount);
        if (isNaN(value)) value = 0;
        return acc + value;
      }
      return acc;
    }, 0);

    const sumRangeWithdraw = data.reduce((acc, item) => {
      const itemDate = format(new Date(item?.updatedAt), "yyyy-MM-dd");
      if (item?.withdraw_uid && itemDate >= startDate && itemDate <= endDate) {
        let value = parseFloat(item.amount);
        if (isNaN(value)) value = 0;
        return acc + value;
      }
      return acc;
    }, 0);

    setTransactionTable({ columns: transColomn, rows: data });

    setTotalDeposit(sumAllDeposit);
    setTotalWithdraw(sumAllWithdraw);

    setRangeDeposit(sumRangeDeposit);
    setRangeWithdraw(sumRangeWithdraw);
  };

  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: clsx(classes.configurator, {
          [classes.configurator_open]: openConfigurator,
          [classes.configurator_close]: !openConfigurator,
        }),
      }}
    >
      <SuiBox
        display="flex"
        justifyContent="space-between"
        alignItems="baseline"
        pt={3}
        pb={0.8}
        px={3}
      >
        <SuiBox flex={1}>
          <SuiTypography component="label" variant="caption" textColor="secondary">
            ค้นหายูสเซอร์ (Username)
          </SuiTypography>
          <SuiBox display="flex" justifyContent="center">
            <SuiBox flex={1}>
              <SuiInput
                defaultValue={username}
                onChange={(event) => {
                  setUsername(event.target.value);
                }}
                type="text"
                placeholder="ยูสเซอร์"
              />
            </SuiBox>
            <SuiBox px={2} ml={1} sx={{ cursor: "pointer" }}>
              <Icon
                className={`font-bold ${classes.configurator_close_icon}`}
                onClick={(event) => handleSearch(event)}
              >
                search
              </Icon>
            </SuiBox>
          </SuiBox>
        </SuiBox>

        <Icon
          className={`font-bold ${classes.configurator_close_icon}`}
          onClick={handleCloseConfigurator}
        >
          close
        </Icon>
      </SuiBox>

      <Divider />

      {member && member?.member_uid && (
        <SuiBox px={3}>
          <SuiBox display="flex" flexDirection="column" lineHeight={1}>
            <SuiTypography variant="h6">ยูสเซอร์: {member?.username}</SuiTypography>

            <Grid container>
              <Grid item xs={12} lg={6}>
                <SuiTypography variant="caption" textColor="text">
                  ชื่อสกุล: {member?.full_name}
                </SuiTypography>
              </Grid>
              <Grid item xs={12} lg={6}>
                <SuiTypography variant="caption" textColor="text">
                  เบอร์โทร: {member?.phone_number}
                </SuiTypography>
              </Grid>
              <Grid item xs={12} lg={6}>
                <SuiTypography variant="caption" textColor="text">
                  ธนาคาร: {member?.bank_name}
                </SuiTypography>
              </Grid>
              <Grid item xs={12} lg={6}>
                <SuiTypography variant="caption" textColor="text">
                  เลขที่บัญชี: {member?.member_bank_number}
                </SuiTypography>
              </Grid>
              <Grid item xs={12} lg={6}>
                <SuiTypography variant="caption" textColor="text">
                  แคมเปญ: {member?.campaign_name}
                  {member?.friend_username ? `(${member?.friend_username})` : ""}
                </SuiTypography>
              </Grid>
              <Grid item xs={12} lg={6}>
                <SuiTypography variant="caption" textColor="text">
                  สมัคร: {member?.createdAt}
                </SuiTypography>
              </Grid>
            </Grid>
          </SuiBox>

          <Divider />

          <SuiBox display="flex" flexDirection="column" mt={3} mb={2} lineHeight={1}>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={4}>
                <SuiBox
                  p={2}
                  display="flex"
                  flexDirection="column"
                  textAlign="center"
                  alignItems="center"
                >
                  <SuiBadge
                    color="success"
                    badgeContent={"ฝากทั้งหมด"}
                    size="small"
                    circular
                    variant="contained"
                  />
                  <SuiTypography mt={1} component="label" variant="caption">
                    {formatter.format(totalDeposit).toString()}
                  </SuiTypography>
                </SuiBox>
              </Grid>
              <Grid item xs={12} lg={4}>
                <SuiBox
                  p={2}
                  display="flex"
                  flexDirection="column"
                  textAlign="center"
                  alignItems="center"
                >
                  <SuiBadge
                    color="error"
                    badgeContent={"ถอนทั้งหมด"}
                    size="small"
                    circular
                    variant="contained"
                  />
                  <SuiTypography mt={1} component="label" variant="caption">
                    {formatter.format(totalWithdraw).toString()}
                  </SuiTypography>
                </SuiBox>
              </Grid>
              <Grid item xs={12} lg={4}>
                <SuiBox
                  p={2}
                  display="flex"
                  flexDirection="column"
                  textAlign="center"
                  alignItems="center"
                >
                  <SuiBadge
                    color={totalDeposit - totalWithdraw < 0 ? "error" : "success"}
                    badgeContent={
                      totalDeposit - totalWithdraw < 0 ? "ขาดทุนทั้งหมด" : "กำไรทั้งหมด"
                    }
                    size="small"
                    circular
                    variant="contained"
                  />
                  <SuiTypography mt={1} component="label" variant="caption" fontWeight="bold">
                    {formatter.format(totalDeposit - totalWithdraw).toString()}
                  </SuiTypography>
                </SuiBox>
              </Grid>
            </Grid>
          </SuiBox>

          <Divider />

          <SuiBox>
            <SuiBox>
              {isPicker && (
                <SuiBox
                  position="absolute"
                  customClass="object-cover object-center"
                  zIndex={99}
                  borderRadius="50"
                  mt={7}
                  backgroundColor="white"
                >
                  <DateRangePicker
                    locale={th}
                    showDateDisplay={false}
                    ranges={[
                      {
                        startDate: new Date(startDate),
                        endDate: new Date(endDate),
                        key: "selection",
                      },
                    ]}
                    onChange={handleSelectDateRange}
                  />
                  <SuiBox display="flex" justifyContent="flex-end" backgroundColor="white" p={2}>
                    <SuiButton
                      variant="gradient"
                      buttonColor="info"
                      size="small"
                      onClick={() => handleFilterDate()}
                    >
                      ตกลง
                    </SuiButton>
                  </SuiBox>
                </SuiBox>
              )}
              <SuiBox onClick={() => setPicker(true)} p={2}>
                <SuiInput
                  value={`${format(new Date(startDate), "dd-MM-yyyy", {
                    locale: th,
                  })} ถึง ${format(new Date(endDate), "dd-MM-yyyy", { locale: th })}`}
                  disabled={true}
                />
              </SuiBox>
            </SuiBox>
          </SuiBox>

          <SuiBox display="flex" flexDirection="column" lineHeight={1}>
            <Grid container spacing={2}>
              <Grid item xs={12} lg={4}>
                <SuiBox
                  p={2}
                  display="flex"
                  flexDirection="column"
                  textAlign="center"
                  alignItems="center"
                >
                  <SuiBadge
                    color="success"
                    badgeContent={"ฝาก"}
                    size="small"
                    circular
                    variant="contained"
                  />
                  <SuiTypography mt={1} component="label" variant="caption">
                    {formatter.format(rangeDeposit).toString()}
                  </SuiTypography>
                </SuiBox>
              </Grid>
              <Grid item xs={12} lg={4}>
                <SuiBox
                  p={2}
                  display="flex"
                  flexDirection="column"
                  textAlign="center"
                  alignItems="center"
                >
                  <SuiBadge
                    color="error"
                    badgeContent={"ถอน"}
                    size="small"
                    circular
                    variant="contained"
                  />
                  <SuiTypography mt={1} component="label" variant="caption">
                    {formatter.format(rangeWithdraw).toString()}
                  </SuiTypography>
                </SuiBox>
              </Grid>
              <Grid item xs={12} lg={4}>
                <SuiBox
                  p={2}
                  display="flex"
                  flexDirection="column"
                  textAlign="center"
                  alignItems="center"
                >
                  <SuiBadge
                    color={rangeDeposit - rangeWithdraw < 0 ? "error" : "success"}
                    badgeContent={rangeDeposit - rangeWithdraw < 0 ? "ขาดทุน" : "กำไร"}
                    size="small"
                    circular
                    variant="contained"
                  />
                  <SuiTypography mt={1} component="label" variant="caption" fontWeight="bold">
                    {formatter.format(rangeDeposit - rangeWithdraw).toString()}
                  </SuiTypography>
                </SuiBox>
              </Grid>
            </Grid>
          </SuiBox>

          <Divider />

          <SuiBox display="flex">
            <SuiBox lineHeight={1} display="flex" justifyContent="center" alignItems="center">
              <SuiBox mr={2}>
                <Switch checked={isFilterTable} onChange={handleSetFilterTable} />
              </SuiBox>
              <SuiTypography variant="button" textColor="text" fontWeight="regular">
                แสดงรายการตามวันที่
              </SuiTypography>
            </SuiBox>
          </SuiBox>

          <SuiBox>
            <AppBar position="static">
              <Tabs orientation="horizontal" value={tabMenu} onChange={handleSetTab}>
                <Tab label="ฝาก/ถอน" />
                <Tab label="โยกเงิน" />
                <Tab label="เพิ่ม/ลดเครดิต" />
              </Tabs>
            </AppBar>
          </SuiBox>

          {tabMenu === 0 && (
            <SuiBox>
              <DataTable
                table={transactionTable}
                showTotalEntries={false}
                isSorted={false}
                noEndBorder
                entriesPerPage={false}
              />
            </SuiBox>
          )}

          {tabMenu === 1 && (
            <SuiBox>
              <DataTable
                table={transferTable}
                showTotalEntries={false}
                isSorted={false}
                noEndBorder
                entriesPerPage={false}
              />
            </SuiBox>
          )}

          {tabMenu === 2 && (
            <SuiBox>
              <DataTable
                table={creditTable}
                showTotalEntries={false}
                isSorted={false}
                noEndBorder
                entriesPerPage={false}
              />
            </SuiBox>
          )}
        </SuiBox>
      )}
    </Drawer>
  );
}

export default Configurator;
